// extracted by mini-css-extract-plugin
module.exports = {"contact":"CustomerSupport_contact__3WAYV","link":"CustomerSupport_link__3VfQX"};